import Cookies from 'universal-cookie';
import { COOKIE_NAMES } from 'lib/enums/cookies';

const getUserGroup = (): string | null => {
  const cookies = new Cookies();

  return cookies.get(COOKIE_NAMES.QH_USER_GROUP) || null;
};

export default getUserGroup;
